import { useEffect, useState } from 'react';
import { useCiAuthStore } from '../auth/ciAuthStore';
import { fetchAuthorizedPools } from '../data/ciApi';
import type { AuthorizedPool } from '../data/types';

interface State {
  loading: boolean;
  pools: AuthorizedPool[];
  error: string | null;
}

/**
 * Retourne la liste des pools sur lesquels l'utilisateur connecté a
 * `dashboardadmin = true`. Source unique d'autorisation côté client.
 */
export function useAuthorizedPools(): State {
  const userId = useCiAuthStore((s) => s.user_id);
  const [state, setState] = useState<State>({ loading: true, pools: [], error: null });

  useEffect(() => {
    let cancelled = false;
    if (!userId) {
      setState({ loading: false, pools: [], error: null });
      return;
    }
    (async () => {
      const { data, error } = await fetchAuthorizedPools(userId);
      if (cancelled) return;
      if (error) {
        setState({ loading: false, pools: [], error: 'Impossible de vérifier vos autorisations.' });
        return;
      }
      setState({ loading: false, pools: data ?? [], error: null });
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return state;
}
